import styled from 'styled-components'
import { colors } from 'theme'

export const LoaderContainer = styled.div`
  flex: 1;
  padding: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > small {
    color: ${colors.color500};
  }
`
